import * as React from 'react';
import { Typography } from '@SBGSports/referee-react';
import styles from './radio-button.module.css';

interface RadioButtonProps {
    value: string;
    isChecked: boolean;
    onChange: (optionValue: string) => void;
    label: string;
    description?: string;
    name: string;
    disabled?: boolean;
    inline?: boolean;
}
export const RadioButton: React.FC<RadioButtonProps> = (props) => {
    const { value, isChecked, onChange, label, description, disabled, name, inline } = props;
    return (
        <div
            className={styles[inline ? 'radio-button-grid-inline' : 'radio-button-grid']}
            onClick={() => {
                if (!disabled) {
                    onChange(value);
                }
            }}
        >
            <div className={styles[inline ? 'radio-button-selector-inline' : 'radio-button-selector']}>
                <input
                    data-testid={value}
                    type="radio"
                    id={value}
                    name={name}
                    value={value}
                    checked={isChecked}
                    disabled={disabled}
                    onChange={(event) => {
                        event.stopPropagation();
                        onChange(event.target.value);
                    }}
                />
            </div>
            <Typography color={disabled ? 'tertiary' : 'catapult-black'} variant="label-1">
                {label}
            </Typography>
            <Typography color={disabled ? 'tertiary' : 'catapult-black'} variant="body-1">
                {description}
            </Typography>
        </div>
    );
};
